<h2 class="popup-heading m-0" mat-dialog-title>Confirmation</h2>
<!-- Normal Case (agar card primary nahi hai ya subscription check null hai) -->
<div class="content" *ngIf="!(check_subscription_plans !== null && cardDetails?.default_method === 1)">
    <p *ngIf="!ErrorMessage">Are you sure you want to delete the below payment method from your account?</p>
    <p *ngIf="ErrorMessage" class="ErrorMessage shake"> {{ ErrorMessage }}</p>

    <mat-card class="payment-card selected">
        <div class="card-header mat-elevation-z0">
            <h4 class="card-title" style="text-transform: capitalize;">
                {{ cardDetails?.details?.card?.brand }}
            </h4>
        </div>
        <div class="card-content">
            <img class="card-logo" [src]="getCardIcon(cardDetails?.details?.card?.brand)"
                [alt]="cardDetails?.details?.card?.brand" />
            <span class="card-number">
                •••• •••• •••• {{ cardDetails?.details?.card?.last4 }}
            </span>
        </div>
        <div class="card-footer payment-footer">
            <span>EXP {{ cardDetails?.details?.card?.exp_month }}/{{ cardDetails?.details?.card?.exp_year }}</span>
        </div>
    </mat-card>

    <mat-dialog-actions class="custom-dialog-actions" align="end">
        <button class="cancel-popup" mat-stroked-button mat-dialog-close (click)="close()">Cancel</button>
        <button class="popup-Delete" mat-button color="warn" (click)="deleteCard()" [disabled]="processing">
            <mat-icon *ngIf="processing">
                <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
            </mat-icon>
            Confirm
        </button>
    </mat-dialog-actions>


</div>

<!-- Error Case (sirf primary card + active subscription ke liye) -->
<div class="content" *ngIf="check_subscription_plans !== null && cardDetails?.default_method === 1">
    <div>
        <span>
            Unfortunately we cannot remove your credit card as you have an active subscription.
            Please cancel your subscription from the Subscription section in order to then remove your credit card.
        </span>
    </div>
    <mat-dialog-actions class="custom-dialog-actions" align="end">
        <button class="cancel-popup" mat-stroked-button mat-dialog-close (click)="close()">Cancel</button>
    </mat-dialog-actions>
</div>